.input-group .input-group-btn button{border-radius:0 8px 8px 0}
/*# sourceMappingURL=invite-index.component-TDWXWVGM.css.map */
